/**
 * 土地関連の換算ユーティリティ
 */

/** 1 坪 = 400/121 平方メートル (約 3.305785) */
export const SQM_PER_TSUBO = 400 / 121;

/**
 * 地積(平方メートル)を坪数へ換算する。
 * 未入力や数値化できない値は null を返す(表示側で「-」等にフォールバックさせる)。
 */
export const sqmToTsubo = (sqm: unknown): number | null => {
  if (sqm === undefined || sqm === null || sqm === '') return null;
  const num = Number(sqm);
  return Number.isFinite(num) ? num / SQM_PER_TSUBO : null;
};
